import CourseMaterialsTab from './CourseMaterialsTab';

export default CourseMaterialsTab;
